import { WidgetDef } from './types';
import capitalStructure from './defs/capitalStructure';
import sharePrice from './defs/sharePrice';
import sharePriceChart from './defs/sharePriceChart';
import topShareholders from './defs/topShareholders';
import asxAnnouncements from './defs/asxAnnouncements';
import presentations from './defs/presentations';
import financialReports from './defs/financialReports';
import noticeOfMeetings from './defs/noticeOfMeetings';
import newsMedia from './defs/newsMedia';
import boardManagement from './defs/boardManagement';
import corporateGovernance from './defs/corporateGovernance';
import companyDetails from './defs/companyDetails';
import contactForm from './defs/contactForm';
import signUp from './defs/signUp';
import accountMenu from './defs/accountMenu';
import signIn from './defs/signIn';
import myAccount from './defs/myAccount';

// every widget, in the order of the spec's list (408:11942). Sample statuses: no website check exists yet.
export const WIDGETS: WidgetDef[] = [
    capitalStructure,
    sharePrice,
    sharePriceChart,
    topShareholders,
    asxAnnouncements,
    presentations,
    financialReports,
    noticeOfMeetings,
    newsMedia,
    boardManagement,
    corporateGovernance,
    companyDetails,
    contactForm,
    signUp,
    accountMenu,
    signIn,
    myAccount,
];

export const findWidget = (slug: string) => WIDGETS.find(w => w.slug === slug);
